// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorUploads = (client) => ({
    /**
     * `POST /vendor/uploads`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUploadsCreate
     * @source packages/modules/b2c-core/src/api/vendor/uploads/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/uploads", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=uploads.js.map